import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ActualizarTiposClientesEnAPI } from "../../action/actionCreatorsRequests";
import { traducirPagina } from "../../librerias/funciones"
import {
    CloseOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import { Select, Card, Drawer, Modal, Button, Form, Input, Checkbox, Row, Col, Tabs } from 'antd';

const FichaCrudTipoCliente = ({ props, configApp }) => {
    const [hayCliente, setHayCliente] = React.useState(false);
    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: 0,
            ID_SOCIO: 0,
            DESCRIPCION: "",
        }
    )




    const modificarRegistro = (ID, ID_SOCIO, DESCRIPCION) => {
        let ACCION = props.ID_REGISTRO === 0 ? 0 : 1

        ActualizarTiposClientesEnAPI(ACCION, ID, ID_SOCIO, DESCRIPCION).then((licencia) => {
            props.ACTUALIZAR_TABLA(null, props.ID_SOCIO);

            props.CERRAR_FICHA(false)

        })

    }



    if (!hayCliente && props.ABRIR_FICHA) {
        setHayCliente(true);

        if (props.ID_REGISTRO > 0) {
            //MODIFICAR
            payLoadLocal.ID = props.REGISTROS.ID
            payLoadLocal.DESCRIPCION = props.REGISTROS.DESCRIPCION
            payLoadLocal.ID_SOCIO = props.REGISTROS.ID_SOCIO

            setPayLoadLocal({ ...payLoadLocal })


        } else {
            //CREAR
            payLoadLocal.ID_SOCIO = props.ID_SOCIO

        }

    } else {
        if (!props.ABRIR_FICHA && hayCliente) {

            setHayCliente(false);


        }
    }



    return (

        <Drawer
            width={600}
            onClose={() => { props.CERRAR_FICHA(false) }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '9999', color: '#fff' }}>

            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {
                        props.CERRAR_FICHA(false);

                    }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>





            {payLoadLocal === null ?
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h4>{traducirPagina("Info_sin_usuario")}</h4>
                </div>
                :
                <>
                    <div className="m-4 container_generico">

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>

                            <Col md={24}>
                                <span>{`${traducirPagina("Descripcion").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24} >
                                <Input name="DESCRIPCION" value={payLoadLocal.DESCRIPCION} onChange={(e) => {
                                    payLoadLocal.DESCRIPCION = e.target.value
                                    setPayLoadLocal({ ...payLoadLocal })
                                }} />
                            </Col>
                        </Row>
                    </div>

                    <div className="m-4" style={{display:'flex',justifyContent:'end'}}>
                        <button className={"botonNuevo"} style={{ backgroundColor: 'var(--azul-claro-serca)', color: 'rgb(255, 255, 255)' }}  onClick={(e) => modificarRegistro(payLoadLocal.ID, payLoadLocal.ID_SOCIO, payLoadLocal.DESCRIPCION)}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                    </div>
                </>
            }
        </Drawer >

    )
}

FichaCrudTipoCliente.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    REGISTROS: PropTypes.object,

    ID_REGISTRO: PropTypes.number,
    ID_SOCIO: PropTypes.number,

    ACTUALIZAR_TABLA: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaCrudTipoCliente);